import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, IconButton } from '@mui/material';
import { DragIndicator as DragIcon } from '@mui/icons-material';
import SensorTile from './SensorTile';

function DraggableSensorTile({ zoneData, onClick, isEditMode, tileSize, backgroundColor, onColorPickerOpen }) {
    const zoneId = zoneData.zone || 'null';

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: zoneId });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        position: 'relative',
    };

    return (
        <Box ref={setNodeRef} style={style}>
            {isEditMode && (
                <IconButton
                    {...attributes}
                    {...listeners}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        zIndex: 10,
                        backgroundColor: 'rgba(255,255,255,0.9)',
                        '&:hover': {
                            backgroundColor: 'rgba(255,255,255,1)',
                            cursor: 'grab',
                        },
                        '&:active': {
                            cursor: 'grabbing',
                        },
                    }}
                    size="small"
                >
                    <DragIcon />
                </IconButton>
            )}
            <SensorTile
                zoneData={zoneData}
                onClick={isEditMode ? () => {} : onClick}
                tileSize={tileSize}
                backgroundColor={backgroundColor}
                onColorPickerOpen={onColorPickerOpen}
                isEditMode={isEditMode}
            />
        </Box>
    );
}

export default DraggableSensorTile;
